import React from "react"
import Label from "@kit/design/label"
import { ColorInput } from "@kit/design/color-picker"
import Icon from "@kit/design/icon"
import { useSavedColors } from "hooks/use-saved-colors"

export function BackgroundColor({ properties, update }) {
  const savedColors = useSavedColors()

  function clearColor() {
    update(
      { backgroundColor: null },
      { localStoragePrefix: `layout-${properties.template}` }
    )
  }

  return (
    <>
      <Label htmlFor="backgroundColor">Background color</Label>
      <div className="relative">
        <ColorInput
          id="backgroundColor"
          name="backgroundColor"
          value={properties.backgroundColor}
          onChange={color =>
            update(
              { backgroundColor: color.hex },
              { localStoragePrefix: `layout-${properties.template}` }
            )
          }
          savedColors={savedColors}
        />
        {properties.backgroundColor && (
          <button
            onClick={clearColor}
            className="top-0 right-0 bottom-0 absolute flex align-center items-center p-2 opacity-50 hover:opacity-100 transition-opacity duration-200"
          >
            <Icon name="close" />
          </button>
        )}
      </div>
    </>
  )
}
